// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"22":"end-user","145":"permission-mgt","204":"direct","216":"container","641":"user-mgt","748":"multinational","855":"e-learning"}[chunkId] + "." + {"22":"fa257726","145":"64e40a29","204":"162eb567","216":"07ab246c","641":"dc38009c","748":"7bacc6c4","855":"cb4614f6"}[chunkId] + ".css";
};